import React from "react";
import { Navigate } from "react-router-dom";
import RouteConstants from "../../constants/routeConstants.json";

const ProtectedRoute = ({ element: Component, featureId, action }) => {
  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];

  const featurePermissions = permissions.find(
    (permission) => permission.feature === featureId
  );

  const hasPermission = featurePermissions && featurePermissions[action];

  return hasPermission ? (
    <Component />
  ) : (
    <Navigate to={RouteConstants.DASHBOARD} />
  );
};

export default ProtectedRoute;
